export const bankManagementcolumnsForExport = [
  { label: "Bank Name", key: "bankName" },
  { label: "IFSC Code", key: "ifscCode" },
  { label: "Mandal", key: "mandal" },
  { label: "City", key: "city" },
  { label: "District", key: "district" },
  { label: "Pin Code", key: "pinCode" },
  { label: "Address", key: "addressLine1" },
  { label: "Contact Name", key: "contactName" },
  { label: "Phone Number", key: "phoneNumber" },
  { label: "Email Address", key: "email" },
  { label: "Website", key: "website" },
  { label: "Active Status", key: "activeStatus" },
];
